import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-record-setting"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    // LocalStorageから現在の設定を読み込み
    const currentSetting = this.getAutoRecordSetting()

    // セレクトボックスに反映
    if (this.hasSelectTarget) {
      this.selectTarget.value = currentSetting
    }
  }

  change() {
    // セレクトボックスの値をLocalStorageに保存
    const value = this.selectTarget.value
    this.saveAutoRecordSetting(value)
  }

  // LocalStorage操作を共通化
  saveAutoRecordSetting(value) {
    localStorage.setItem('autoRecordEnabled', value)
  }

  getAutoRecordSetting() {
    // デフォルトは "false" (OFF)
    const saved = localStorage.getItem('autoRecordEnabled')
    return saved !== null ? saved : 'false'
  }
}
